import axios from 'axios';
import get from 'lodash/get';

export function getLastUnratedAppointment(success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/appointments/last_unrated`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        const appointment = response.data.data;
        if (appointment) {
          success && success(appointment);
        }
      })
      .catch(result => {
        failure && failure(result);
      });
  };
}

export function skipRating(appointmentId, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/appointments/${appointmentId}/skip_rating`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`
          }
        }
      )
      .then(response => {
        success && success(response);
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        failure && failure(response);
      });
  }
}

export function submitRating(appointmentId, attrs, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/appointments/${appointmentId}/rate`,
        attrs,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`
          }
        }
      )
      .then(response => {
        success && success(response);
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        failure && failure(response);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/ratingActions.js